module.exports = __webpack_public_path__ + "img/guatemala.bc7d943.webp";